module.exports = __webpack_public_path__ + "static/img/airoad_combination01.c5a701ce.png";